module.exports = __webpack_public_path__ + "img/bookmark_II.c6615a8b.svg";